import includes from 'lodash/includes'
import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface ICalendarEvent {
  [key: string]: any
}

class CalendarEvent extends Model<ICalendarEvent> {
  static urlRoot() {
    return '/calendar_events'
  }

  constructor(attr: ICalendarEvent = {}) {
    super(attr)
    makeObservable(this, {
      leaveType: computed,
    })
  }

  metadata(attribute: string) {
    return (this.attributes.metadata || {})[attribute]
  }

  /**
   * TODO: Until now leave_type returned ['holiday', 'sick', 'other']
   * Now it returns `custom` for company custom leave types
   * We need this `type` to set translations and css classes
   * Now this is assigning to `other` to avoid explode. But we need to handle
   * custom types
   */
  get leaveType(): string {
    const type = this.metadata('leave_type')

    if (type && includes(['holiday', 'sick', 'other'], type)) return type

    return 'other'
  }
}

export default CalendarEvent
